<template>
  <div>
    <div>
      <!-- Carousel Desktop -->
      <b-carousel :pause-info="false" :indicator="true" :icon-prev="iconPrev" :icon-next="iconNext" style="position: relative; margin-top: -7rem;" class="homepage-carousel is-hidden-touch">
        <b-carousel-item v-for="(carouselHomepageContent, index) in carouselHomepageContents" :key="index">
          <div class="bg-img is-flex is-justify-content-center is-align-items-center banner-section-homepage" :style="'background: url(' + carouselHomepageContent.image_url + ') center;'">
            <div class="container is-fluid px-0">
              <div class="is-flex is-justify-content-center is-align-items-center mb-6 px-6">
                <h1 class="pb-header color-white">{{carouselHomepageContent.title}}</h1>
                <div class="vertical-divider"></div>
                <h1 class="pb-title-2 carousel-subtitle is-narrow has-text-left color-white">{{carouselHomepageContent.subtitle}}</h1>
              </div>
              <div v-show="carouselHomepageContent.showButton == true">
                <router-link :to="{ name: 'about-us'}">
                  <b-button class="join-us-btn" icon-right="mdi mdi-play">{{carouselHomepageContent.buttonText}}</b-button>
                </router-link>
              </div>
            </div>
          </div>
        </b-carousel-item>
      </b-carousel>

      <div class="is-hidden-desktop">
        <!-- Carousel Mobile -->
          <b-carousel :pause-info="false" :indicator="true" :icon-prev="iconPrev" :icon-next="iconNext" class="homepage-carousel-mobile">
          <b-carousel-item v-for="(carouselHomepageContent, index) in carouselHomepageContents" :key="index">
            <div class="bg-img is-flex is-justify-content-center is-align-items-center" :style="'background: url(' + carouselHomepageContent.image_url + ') center; height: 800px;'">
              <div class="container is-fluid px-0">
                <div class="is-flex is-flex-direction-column is-justify-content-center is-align-items-center px-6">
                  <h1 class="pb-title color-white">{{carouselHomepageContent.title}}</h1>
                  <div class="vertical-divider py-0 my-0"></div>
                  <h1 class="mt-4 color-white pb-title carousel-subtitle">{{carouselHomepageContent.subtitle}}</h1>
                  <div v-show="carouselHomepageContent.showButton == true">
                    <router-link :to="{ name: 'about-us'}">
                      <b-button class="join-us-btn" icon-right="mdi mdi-play">{{carouselHomepageContent.buttonText}}</b-button>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </b-carousel-item>
        </b-carousel>
      </div>
    </div>

    <!-- Welcome section -->
    <div class="pb-large-title welcome-text colour-primary-01 has-text-left">WELCOME</div>
    <div>
      <div class="columns is-mobile is-desktop mb-6">
        <div class="column is-full-mobile is-two-thirds-desktop">
          <div class="bg-img card is-flex is-align-items-center home-2-1" style="border-bottom: 10px solid #FDB913; box-shadow: 0px 2px 30px 5px rgba(0,0,0,0.4)">
            <div class="card-content welcome-box has-text-left">
                <h2 class="pb-header color-white">What's Happening?</h2>
                <p class="color-white pt-4">AHAM Capital Wealth Partners brings together wealth management consultants under AHAM Asset Management Berhad (“AHAM Capital”) to serve the needs of corporates, institutions, pension funds, government-linked companies, high-net-worth individuals, and the mass affluent.</p>
                <router-link :to="{ name: 'happenings'}">
                  <b-button type="" class="button main mt-4">
                    <div>Learn More <b-icon class="ml-1" icon="play" size="is-small"></b-icon></div>
                  </b-button>
                </router-link>
              </div>
          </div>
        </div>
      </div>
      

      <div class="columns is-mobile is-desktop mb-6 is-justify-content-flex-end">
        <div class="column is-full-mobile is-two-thirds-desktop">
          <div class="bg-img welcome-text-section card is-flex is-align-items-center home-2-2" style="border-bottom: 10px solid #FDB913; box-shadow: 0px 2px 30px 5px rgba(0,0,0,0.4)">
              <div class="card-content weekly-market-box has-text-left">
                <h2 class="pb-header color-white">Weekly Market Review</h2>
                <p class="color-white pt-4">Get insightful and concise summary of the week's significant market movements. From understanding key shifts in major indices, and corporate earnings, to economic indicators, delivering an essential snapshot of the financial landscape.</p>
                <router-link :to="{ name: 'weekly-market-review'}">
                  <b-button type="" class="button main mt-4">
                    <div>Learn More <b-icon class="ml-1" icon="play" size="is-small"></b-icon></div>
                  </b-button>
                </router-link>
              </div>
          </div>
        </div>
      </div>

      <div class="columns is-mobile is-desktop mb-6">
        <div class="column is-full-mobile is-two-thirds-desktop">
          <div class="bg-img card is-flex is-align-items-center home-2-3" style="border-bottom: 10px solid #FDB913; box-shadow: 0px 2px 30px 5px rgba(0,0,0,0.4)">
            <div class="card-content welcome-box has-text-left">
              <h2 class="pb-header color-white">Dose of Motivation</h2>
              <p class="color-white pt-4">Bringing you tips, insightful strategies, and inspiration to guide you to be your best self and thrive as a consultant.</p>
              <router-link :to="{ name: 'dose-motivation'}">
                <b-button type="" class="button main mt-4">
                  <div>Learn More <b-icon class="ml-1" icon="play" size="is-small"></b-icon></div>
                </b-button>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Track record -->
    <h1 class="pb-title track-record-title">AHAM ASSET MANAGEMENT'S TRACK RECORD</h1>
    <div class="section has-bg-img2 is-large pt-6 track-record-section">
      <div class="container track-record-container">
        <div class="columns is-12 is-mobile is-desktop is-tablet is-multiline">
          <div class="column is-12-mobile is-3-tablet is-3-desktop track-record-box">
            <div class="track-record-content bg-white">
              <img src="../assets/icons/total-AUA.png">
              <h1 class="pb-header mt-6">{{statistic.total_aua}}</h1>
              <p class="pb-subtitle-2" style="">{{staticText[0]}}</p>
            </div>
          </div>
          <div class="column is-12-mobile is-3-tablet is-3-desktop track-record-box">
            <div class="track-record-content bg-white">
              <img src="../assets/icons/total-fund.png">
              <h1 class="pb-header mt-6">{{statistic.total_funds}}</h1>
              <p class="pb-subtitle-2" style="">{{staticText[1]}}</p>
            </div>
          </div>
          <div class="column is-12-mobile is-3-tablet is-3-desktop track-record-box">
            <div class="track-record-content bg-white">
              <img src="../assets/icons/state-malaysia.png" class="state-icon">
              <h1 class="pb-header mt-6">{{statistic.total_states}}</h1>
              <p class="pb-subtitle-2 state-text" style="">{{staticText[2]}}</p>
            </div>
          </div>
          <div class="column is-12-mobile is-3-tablet is-3-desktop track-record-box">
            <div class="track-record-content bg-white">
              <img src="../assets/icons/award.png">
              <h1 class="pb-header mt-6">{{statistic.total_awards}}</h1>
              <p class="pb-subtitle-2" style="">{{staticText[3]}}</p>
            </div>
          </div>
        </div>
      </div>
      <p class="has-text-centered colour-secondary-02 number-source">Source: AHAM Asset Management as of {{statistic.data_source}}</p>
    </div>

    <!-- Events section -->
    <h1 v-if="events.length > 0" class="pb-title event-activities-title">EVENTS & ACTIVITIES</h1>
    <div v-if="events.length > 0" class="mb-6 container" id="event-carousel">
      <b-carousel-list :data="events" v-bind="al" :icon-prev="iconPrev" :icon-next="iconNext">
        <template #item="list">
          <div class="py-3 px-5 has-text-left">
            <router-link :to="{ name: 'course-summary', query: {courseId: list.attributes.uuid}}">
              <b-image class="image is-square" :src="list.attributes.image.data ? list.attributes.image.data.attributes.url : require('@/assets/img/default_photo_big.jpg')"></b-image>
            </router-link>           
            <div class="is-flex is-flex-direction-column is-justify-content-space-between event-card-box">
              <p class="pt-5 pb-title ellipsis-title">{{ list.attributes.title ? list.attributes.title : '' }}</p>
              <a class="text-link">
                <b-button class="button-secondary-background has-text-left" icon-right="mdi mdi-play" 
                @click="isAuthenticated ? viewDetails(list.attributes.date, list.attributes.uuid) || changeEvent(list.attributes.programType) : $router.push({name:'course-registration-form',  query: {courseId: list.attributes.uuid}})" :disabled="periodRange(list.attributes.registration_start, list.attributes.registration_end) ? true : false" 
                >
                Join Now
              </b-button>
              </a>
            </div>
          </div>
        </template>
      </b-carousel-list>
    </div>

    <!-- Follow Us section -->
    <h1 class="pb-header follow-us-title" style="margin-bottom: 10rem;">#AWPMOMENTS</h1>
    <div class="section follow-us-section">
      <div class="moment-carousel-container">
        <b-carousel-list :data="moments" v-bind="item" :icon-prev="iconPrev" :icon-next="iconNext" id="moment-carousel">
          <template #item="{list}">
            <div class="p-3 has-text-left">
              <a :href="list.redirect_link ? list.redirect_link : '#'" target="_blank">
                <b-image class="image is-square" :src="list.image_url" ></b-image>
              </a>          
            </div>
          </template>
        </b-carousel-list>
      </div>
      <div class="follow-us-box">
        <p class="pb-title color-white-2">Follow Us on Social Media</p>
      </div>
      <div class="is-flex is-justify-content-end">
        <ScrollTop />
      </div>
    </div>
    <!-- Modal (hidden) -->
    <b-modal v-model="isModalActive" :can-cancel="false" style="padding: 0 1rem;">
      <div class="modal-card" style="margin: auto;">
        <header class="modal-card-head pt-2 pb-2 pl-2 pr-2 modal-header" style="background: #730039; border-radius: 0px; height: 50px;">
          <p class="modal-card-title"></p>
          <b-button class="close-btn" style="background: transparent !important;" @click="isModalActive = false"><b-icon icon="close" style="color:#FFFFFF; cursor: pointer; height: 100%"></b-icon></b-button>
        </header>

        <div class="modal-card-body pl-5 pr-5 pt-5 pb-5">
          <div class="has-text-centered">
            <div class="pop-up-text">
              <p class="pl-5 pr-5" style="color: #363636;">You will need to join as consultant to sign up for the campaign, please contact our business development manager to understand more.</p>
              <hr class="divider">
              <div class="">
                <div class="wrapper-contact">
                  <div>
                    <a href="tel:+1-800-22-2288" class="is-flex is-align-items-center">
                      <img class="mr-2 has-text-left" src="@/assets/icons/pop-up-call.svg" />
                      <span class="colour-text">Tel: 1800-22-2288</span>
                    </a>
                  </div>
                  <div>
                    <a href="mailto:parasupport@aham.com.my" class="is-flex is-align-items-center">
                      <img class="mr-2 has-text-left" src="@/assets/icons/email.png" />
                      <a href="mailto:parasupport@aham.com.my" target="_self" class="colour-text">parasupport@aham.com.my</a>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal v-model="isConfirm" style="padding: 0 1rem;">
      <div class="modal-card" style="margin: auto;">
        <header class="modal-card-head pt-2 pb-2 pl-2 pr-2 modal-header"
          style="background: #730039; border-radius: 0px; height: 50px;">
          <p class="modal-card-title"></p>
          <b-button class="close-btn" style="background: transparent !important;" @click="isConfirm = false"><b-icon
              icon="close" style="color:#FFFFFF; cursor: pointer; height: 100%"></b-icon></b-button>
        </header>

        <div class="modal-card-body pl-5 pr-5 pt-5 pb-5">
          <div class="has-text-centered">
            <div class="pop-up-text">
              <p class="pl-5 pr-5" style="color: #363636;">Would you like to secure your spot for this {{eventType}}?</p>
              <br>
              <div class="">
                <b-button class="pl-6 pr-6 mr-5" style="color:#730039;border:1px solid #730039;background-color: white;"
                  @click="isConfirm = false">No</b-button>
                <b-button class="button dark-red pl-6 pr-6" @click="register(modalDate, modalUuid)">Yes</b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal v-model="registerSuccess" style="padding: 0 1rem;">
      <div class="modal-card" style="margin: auto;">
        <header class="modal-card-head pt-2 pb-2 pl-2 pr-2 modal-header"
          style="background: #730039; border-radius: 0px; height: 50px;">
          <p class="modal-card-title"></p>
          <b-button class="close-btn" style="background: transparent !important;" @click="registerSuccess = false"><b-icon
              icon="close" style="color:#FFFFFF; cursor: pointer; height: 100%"></b-icon></b-button>
        </header>

        <div class="modal-card-body pl-5 pr-5 pt-5 pb-5">
          <div class="has-text-centered">
            <div class="pop-up-text">
              <p class="pl-5 pr-5" style="color: #363636;">You have successfully registered for the {{eventType}}.</p>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <b-loading :is-full-page="true" v-model="isLoading">
      <b-icon pack="mdi" icon="loading" size="is-large" custom-class="mdi-spin">
      </b-icon>
    </b-loading>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import ScrollTop from '../components/ScrollTop.vue';
import axios from 'axios';

export default {
  data() {
    return {
      eventType:'',
      registerSuccess:false,
      isLoading:false,
      isConfirm: false,
      modalDate:'',
      modalUuid:'',
      isModalActive: false,
      hideBanner: false,
      features: [],
      news: [],
      articles: [],
      events: [],
      eventSize: 6,
      dataLength: 0,
      eventsByTodayDate: [],
      statistic: [],
      enrollList: [],
      moments:[],
      carouselHomepageContents:[],
      carouselEventContents: [],
      staticText: ['of Total AUA','Total No. of Funds','States across Malaysia', 'Awards since 2001'],
      values: 1,
      iconPrev: 'menu-left',
      iconNext: 'menu-right',
      al: {
        itemsToShow: 1,
        breakpoints: {
            476: {
                itemsToShow: 2
            },
            768: {
                itemsToShow: 3
            },
            1300: {
                itemsToShow: 3
            }
        }
      },
      item: {
        itemsToShow: 2,
        breakpoints: {
            425: {
                itemsToShow: 3
            },
            768: {
                itemsToShow: 4
            },
            1023: {
                itemsToShow: 5
            },
            1280: {
                itemsToShow: 6
            }
        }
      }
    }
  },
  components: {
    ScrollTop
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();

    let year = dayjs().year() - 3;
    await this.$httpClientCMS({       // GET statistic data
      method: 'GET',
      url: 'api/static-fields-homepage'
    })
    .then(resp => {
      let data = resp.data.data.attributes;
      this.$set(this, 'statistic', data);
    })
    .catch((error) => {
      this.$router.push('maintenance');
    });
    await this.$httpClientCMS({
      method: 'GET',
      url: 'api/carousel-homepage'
    })
    .then(resp => {
      let homepageCarouselFromApi = resp.data.data.attributes.carousel_data;
      homepageCarouselFromApi.forEach((e) => {
          this.carouselHomepageContents.push(e);
      });
    });
    // Get Events
    await this.$httpClientCMS({
      method: 'GET',
      url: 'api/events?populate=*&filters[targetUser][$eq]=Public&sort=date:desc&filters[date][$gte]=' + year + '-01-01'
    })
    .then(resp => {
      let eventCarouselFromApi = resp.data.data;
      eventCarouselFromApi.forEach((e) => {
          this.carouselEventContents.push(e);
      });
    });

    await this.$httpClientCMS({
      method: 'GET',
      url: 'api/carousel-share-pb-moment'
    })
    .then(resp => {
      let momentsFromApi = resp.data.data.attributes.carousel_data;
      momentsFromApi.forEach((e) => {
          this.moments.push(e);  
      });
      this.moments.sort((a, b) => {
          let aDate = new Date(a.timestamp);
          let bDate = new Date(b.timestamp);

          return bDate - aDate;
      });
    });

    this.fetchData('news-and-annoucements?sort=date:desc&filters[date][$gte]=' + year + '-01-01', this.news);
    this.fetchData('articles?sort=date:desc&filters[date][$gte]=' + year + '-01-01', this.articles);
    await this.$httpClientCMS({     // GET social media link
      method: 'GET',
      url: 'api/features?populate=type=instagram*&sort=date:desc&filters[date][$gte]=' + year + '-01-01'
    })
    .then(resp => {
      let features = resp.data.data;
      this.$set(this, 'features', features);
      let dataLength = features.length;
      this.total = parseInt(dataLength / 5) + 1;
    })

    if (this.isAuthenticated){
      this.fetchData('events?populate=*&sort=date:desc&filters[date][$gte]=' + year + '-01-01', this.events);
    }else{
      this.fetchData('events?populate=*&filters[targetUser][$eq]=Public&sort=date:desc&filters[date][$gte]=' + year + '-01-01', this.events);
    }

    loadingComponent.close()
    
  },
  methods: {
    changeEvent(type) {
      this.eventType = type
    },
    register(date, courseId) {
      this.isConfirm = false;
      this.isLoading = true
      //if consultant
      if (this.isAuthenticated) {
        this.fullname = this.$store.state.user.name
        this.email = this.$store.state.user.email
        // POST to endpoint (consultant)
        let month = dayjs(date).month() + 1;
        let year = dayjs(date).year();
        let startDate = year + '-' + month + '-01';
        let end = dayjs(startDate).daysInMonth();     // number of days in a month (28-31)
        let endDate = year + '-' + month + '-' + end;
        this.$httpClient({
          method: "GET",
          url: "/pbmicrosite/enroll/" + this.$store.state.user.uuid + "?startdate=" + startDate + "&enddate=" + endDate,
        }).then((resp) => {
          let enroll = resp.data.filter(i => i.CourseId === courseId.toString());
          if (enroll.length > 0) {
            this.$buefy.toast.open({
              message: 'This course is registered',
              type: 'is-danger'
            })
            this.registerSuccess = false;
            this.isLoading = false
          } else {
            // POST to endpoint
            this.$httpClient.post("/pbmicrosite/register/" + courseId,
              {
                ParticipantId: this.$store.state.user.uuid.toString(),
                ParticipantType: 1,
                Fullname: this.fullname.toString(),
                Email: this.email.toString()
              })
              .then(resp => {
                if (resp.data.EnrollStatus === true) {
                  // this.$buefy.toast.open({
                  //   message: 'You have successfully registered into the course',
                  //   type: 'is-success'
                  // })

                  //popup modal success
                  this.registerSuccess = true;
                  this.isLoading = false
                }
              })
              .catch((error) => {
                this.$buefy.toast.open({
                  message: 'This course is full, registration denied',
                  type: 'is-danger'
                })
                this.registerSuccess = false;
                this.isLoading = false
              });
          }
        });
      }
      //if public
      else {
        // POST to endpoint (public)
        this.$httpClient.post("/internal/pbmicrosite/register/" + courseId,
          {
            ParticipantType: 0,
            PbNric: this.nric.toString(),
            PbFirstname: this.firstname.toString(),
            PbLastname: this.lastname.toString(),
            PbFullname: this.fullname.toString(),
            PbEmail: this.email.toString(),
            PbPhoneno: this.phone.toString()
          })
          .then(resp => {
            if (resp.data.EnrollStatus === true) {
              this.$buefy.toast.open({
                message: 'You have successfully registered into the course',
                type: 'is-success'
              })
              location.reload();
            }
          })
          .catch((error) => {
            this.$buefy.toast.open({
              message: 'This course is full, registration denied',
              type: 'is-danger'
            });
            this.registerSuccess = false;
            this.modalActive = false;
          });
      }
    },
    fetchData(apiName, content){
      this.$httpClientCMS({
        method: 'GET',
        url: 'api/' + apiName
      })
      .then(resp => {
        let array = resp.data.data.slice(0,5);
        array.forEach((e)=> {
          content.push(e);
        })
        if(this.isAuthenticated && apiName.includes("event")){
          this.getEnrollList(array);
        }
      })
      .catch((error) => {
        this.$router.push('maintenance');
      });
    },
    formatDate(apiDate){
      return dayjs(apiDate).format('DD MMMM YYYY');
    },
    formatEventDate(eventDate){
      return dayjs(eventDate).format('DD MMM YYYY');
    },
    formatTime(apiTime){
      let timeArr = apiTime.split(":");
      let date = new Date(2018, 11, 24, timeArr[0], timeArr[1], 30, 0);
      return dayjs(date).format('h:mmA');
    },
    viewDetail(url){
      if(url!==null){
        window.open(url, '_blank').focus();
      }else{
        this.$buefy.toast.open('PDF file not available')
      }
    },
    viewDetails(dataDate, dataUuid) {
      if (this.isAuthenticated) {
        this.isConfirm = true;
        this.modalUuid = dataUuid;
        this.modalDate = dataDate;
      } else {
        this.isModalActive = true;
      }
    },
    checkRegistrationStatus(programDate, startTime){
      let today = new Date();
      let pastProgram = Date.parse(programDate) < today;
      let timeArr = startTime.split(':');
      let scheduleTime = (timeArr[0] * 60) + parseInt(timeArr[1]);
      let currentTime = (today.getHours() * 60) + today.getMinutes();
      if(pastProgram === false || ((dayjs(today).format('YYYY-MM-DD') === programDate) && currentTime < scheduleTime)){
        return false;
      }else{
        return true;
      }
    },
    onRegister(course){
      if (this.isAuthenticated) {
        let enroll = this.enrollList.filter(i => i.CourseId === course.attributes.uuid.toString());
        if(enroll.length > 0){
          this.$buefy.toast.open({
            message: 'This course is registered',
            type: 'is-danger'
          })
        }else{
          this.$router.push({name: 'course-registration-form', query: {courseId: course.attributes.uuid}});
        }
      }
      else{
        let routeData = this.$router.resolve({name: 'course-registration-form', query: {courseId: course.attributes.uuid}});
        window.open(routeData.href, '_blank');
      }
    },
    getEnrollList(events){
      let eventsAfterToday = events.filter(i => Date.parse(i.attributes.date) >= Date.parse(dayjs()));
      if(eventsAfterToday.length > 0){
        let endDate = eventsAfterToday[0].attributes.date;
        let startDate = eventsAfterToday[eventsAfterToday.length - 1].attributes.date;
        this.$httpClient({
          method: "GET",
          url: "/pbmicrosite/enroll/" + this.$store.state.user.uuid + "?startdate=" + startDate + "&enddate=" + endDate,
        }).then((resp) => {
          this.$set(this, "enrollList", resp.data);
        });
      }
    },
    checkRegisterLabel(programId){
      if(this.isAuthenticated){
        let enroll = this.enrollList.filter(i => i.CourseId === programId);
        if(enroll.length > 0){
          return 'REGISTERED';
        }
      }
      return 'Join Now';
    },
    checkRegisterIcon(programId){
      if(this.isAuthenticated){
        let enroll = this.enrollList.filter(i => i.CourseId === programId);
        if(enroll.length > 0){
          return 'check';
        }
      }
      return 'play';
    },
    goToTop(){
      window.scrollTo(0, this.top);
    },
    periodRange(startDate, endDate) {
      let today = new Date()
      let nStartDate = new Date(startDate)
      //let end date + 1 day
      let nEndDate = new Date(endDate)
      nEndDate.setDate(nEndDate.getDate() + 1)

      //if today is between start and end date
      if (today.getTime() >= nStartDate.getTime() && today.getTime() < nEndDate.getTime()) {
        return false
      }
      else {
        return true
      }
    },
  },
  computed: {
      isAuthenticated() {
          return this.$store.getters['auth/isAuthenticated']
      }
  }
}
</script>

<style lang="scss" scoped>
// top banner

.home-2-1 {
  background: url('../assets/img/home-2-whats-happening.jpg') center !important; 
  background-repeat: no-repeat !important;
  background-size: cover !important;
}

.home-2-2 {
  background: url('../assets/img/home-2-weekly-desktop.jpg') center !important;
  background-repeat: no-repeat !important;
  background-size: cover !important;
}

.home-2-3 {
  background: url('../assets/img/home-2-dose-motivation-desktop.jpg') center !important;
  background-repeat: no-repeat !important;
  background-size: cover !important;
}

.home-red-bg {
  background: url('../assets/img/home-track-record-bg.jpg') center !important;
  background-repeat: no-repeat !important;
  background-size: cover !important;
}

.wrapper-contact {
  display: flex;
  justify-content: space-around;
}

.icon-container{
  display: flex;
  flex-direction: row;
}
.banner-section-homepage {
  min-height: 880px;
}
.carousel-subtitle{
  font-family: 'GothamBook';
  max-width: 500px;
}

// welcome section
  .welcome-text{
    margin: 4.5rem 10rem;
  }
  .card{
    box-shadow: none;
    background: transparent;
    height: 400px;
    max-height: 100%;
    border-radius: 0;
  }

  .welcome-box{
    margin-left: 14.7rem;
    // margin-right: 12.8rem;
    max-width: 650px;
  }

  .weekly-market-box{
    margin-left: 7.75rem;
    max-width: 650px;
    // margin-right: 19.75rem;
  }

  // track record section

  .track-record-title{
    margin: 5rem 10rem;
    // margin-bottom: 10rem;
  }
  .track-record-container{
    margin-top: -120px;
  }

  .pb-subtitle-2{
    margin: 0.6rem;
  }

  .event-activities-title{
    margin-top: 5rem;
  }

// Carousel desktop
:deep() {

  .carousel-arrow .icon.has-icons-left {
    left: unset;
  }

  .carousel {
    .carousel-list {
      padding-top: 5rem;
    }

    .slider-counter {
      position: absolute;
      top: 50%;
      right: 20%;
    }

    .carousel-text-container{
      position: absolute;
      width: 100%;
      height: 350px;
      left: 0px;
      top: 311px;
      justify-content: space-around;
      align-items: center;
      padding: 0 10rem;
    }

    .carousel-arrow {
      opacity: 1 !important;
      .icon {
        color: #363636;
        &.has-icons-left {
          top: 90%;
          background-color: #FDB913;
          padding: 1rem;
          border-radius: 0;
          border: 0;
          width: 52px;
          right: 55%;
          // transform: translate(-50%, -50%);
          display: flex !important;
        }
        &.has-icons-right {
          top: 90%;
          background-color: #FDB913;
          padding: 1rem;
          border-radius: 0;
          border: 0;
          width: 52px;
          right: 40%;
          // transform: translate(-50%, -50%);
          display: flex !important;
        }
      }
    }

    .carousel-indicator.is-inside.is-bottom{
      // bottom: 6rem !important;
    }


    .carousel-indicator .indicator-item .indicator-style.is-dots{
      border-radius: 10%;
      width: 15px;
      height: 15px;
      opacity: 60%;
    }

    .carousel-indicator .indicator-item.is-active .indicator-style, .carousel .carousel-indicator .indicator-item .indicator-style:hover{
      background: #FFFFFF;
      border: 1px solid #FFFFFF;
      opacity: 100%;
    }

  }
}

// Carousel mobile
:deep(){
  .homepage-carousel-mobile {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    background-size: cover;
    background-repeat: no-repeat;
    margin-top: -7rem;

    .carousel-text-container {
      display: flex;
      justify-content: center;
      z-index: 1;
      margin-block: unset;
      flex-wrap: wrap;
      position: absolute;
      display: flex;
      width: 100%;
      height: 350px;
      left: 0px;
      top: 311px;
      justify-content: space-around;
      align-items: center;
      padding: 0 10rem;
    }

    .carousel-text-container .join-us-btn{
      // width: 100px;
      background: #FDB913;
      font-weight: 400;
      color: #363636;
      font-size: 16px;
      margin-right: 25px;
      height: auto !important;
      white-space: break-spaces !important;
    }

    .carousel-arrow {
      opacity: 1 !important;
      .icon {
        color: #363636;
        &.has-icons-left {
          top: 90%;
          background-color: #FDB913;
          padding: 1rem;
          border-radius: 0;
          border: 0;
          width: 10px !important;
          right: 63%;
          display: flex !important;
        }
        &.has-icons-right {
          top: 90%;
          background-color: #FDB913;
          padding: 1rem;
          border-radius: 0;
          border: 0;
          width: 10px !important;
          right: 26% !important;
          display: flex !important;
        }
      }
    }

    .carousel-indicator.is-inside.is-bottom{
      bottom: 6rem !important;
      margin:  0 !important;
    }

    .carousel-indicator .indicator-item .indicator-style.is-dots{
      border-radius: 10%;
      width: 15px;
      height: 15px;
      opacity: 60%;
    }

    .carousel-indicator .indicator-item.is-active .indicator-style, .carousel .carousel-indicator .indicator-item .indicator-style:hover{
      background: #FFFFFF;
      border: 1px solid #FFFFFF;
      opacity: 100%;
    }
  }
}


.pb-banner-title{
  color:#2B2D47;
}

.pb-banner-title{
  color:#2B2D47;
}

.join-us-btn{
  // width: 150px;
  background: #FDB913;
  font-weight: 400;
  color: #363636;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  height: auto !important;
  white-space: break-spaces !important;
}

// Welcome
.welcome-title {
  font-family: "Gotham";
  font-weight: 700;
  font-size: 3rem !important; /* 48px */
}

.welcome-subtitle{
  font-family: 'Open Sans';
  font-weight: 400;
  font-size: 1.25rem;
}

#weekly-market-section{
  border-bottom: 3px solid #FDB913;
  width: 1200px;
  max-height: 400px;
  height: 100%;
  position: relative;
  transform: translate(57%, 0);
  border-bottom: 10px solid #FDB913;
}

.join-event-btn:hover{
  cursor: pointer;
}

// Track Record

.button-icon-text-v1{
  text-decoration: none;
}

.track-record-section{
  height: 425px;
  margin-top: 10rem;
}

.track-record-content{
  width: 100%;
  // max-height: 100%;
  height: 400px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 4px 30px 5px rgba(0,0,0,0.1);
}

.number-source{
  margin-top: 30px;
}

// Event & Activities
// Event Carousel
.button-secondary-background{
  background-color: #730039;
  color: #FFFFFF;
}


:deep(){
  #event-carousel {
    .carousel-indicator{
      display: none;
    }

    .carousel-list {
      padding-top: 3rem;
    }

    .carousel-list.has-shadow {
      box-shadow:none !important;
    }

    .carousel-arrow {
      opacity: 1 !important;
      .icon {
        color: #363636;
        &.has-icons-left {
          top: 5%;
          background-color: #FDB913;
          padding: 1rem;
          border-radius: 0;
          border: 0;
          width: 52px;
          right: 5.5%;
          display: flex !important;
        }
        &.has-icons-right {
          top: 5%;
          background-color: #FDB913;
          padding: 1rem;
          border-radius: 0;
          border: 0;
          width: 52px;
          right: 2.5%;
          display: flex !important;
        }
      }
    }
  }
}

.event-card-box{
  min-height: 135px;
  height: 100%;
}

.divider{
  display: flex;
  height: 1px;
  flex-direction: column;
  align-items: flex-start;
  color: #E0E0E0 !important;
  padding: 0rem !important;
}

.colour-text{
  text-decoration: underline;
}

// AWP Moment

.follow-us-title{
  text-decoration: underline;
  text-decoration-thickness: 6px;
  text-underline-offset: 0.3rem;
  margin-bottom: 12rem;
}

.moment-carousel-container{
  margin-top: -13rem;
}

:deep(){
  #moment-carousel {
    box-shadow:none !important;
    #moment-carousel{
      position: relative;
      bottom:100px;
    }
    .carousel-indicator{
      display: none;
    }

    
    .carousel-arrow {
      opacity: 1 !important;
      .icon {
        color: #363636;
        &.has-icons-left {
          top: 50%;
          background-color: #FDB913;
          padding: 1rem;
          border-radius: 0;
          border: 0;
          width: 52px;
          left: 0px;
          display: flex;
        }
        &.has-icons-right {
          top: 50%;
          background-color: #FDB913;
          padding: 1rem;
          border-radius: 0;
          border: 0;
          width: 52px;
          right: 0;
          display: flex;
        }
      }
    }
  }
}

.follow-us-section{
  background-color: #2B2D47;
}

.follow-us-box{
  margin-top: -6rem;
  margin-bottom: 3rem;
}

.vertical-divider{
  border-right: 5px solid #F5F5F5;
  margin: 0 1rem;
  padding-left: 5px;
  height: 70px;
}

.has-bg-img2 {
  background: url("../assets/img/home-track-record-bg.jpg") center center;
  background-size:cover;
}

.ellipsis-title{
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}


@media screen and (min-width: 1810px){
  .follow-us-box{
    margin-top: -8rem !important;
    margin-bottom: 5.65rem !important;
  }
}

@media (min-width: 1661px){
  .close-btn{
    padding-right: 0.5em;
  }
  .banner-section-homepage {
    min-height: 1080px;
  }

  .track-record-container{
    margin-top: -10rem;
  }

  .ellipsis-title{
    min-height: 95px;
  }

  .welcome-box{
    margin-left: 11.7rem;
    margin-right: 7.8rem;
  }

  .weekly-market-box{
    margin-left: 7.75rem;
    // margin-right: 14.75rem;
  }

  .event-card-box{
    min-height: 200px;
    height: 100%;
  }

  :deep() {

.carousel-arrow .icon.has-icons-left {
  left: unset;
}

.carousel {
  .carousel-list {
    padding-top: 5rem;
  }

  .slider-counter {
    position: absolute;
    top: 50%;
    right: 20%;
  }

  .carousel-text-container{
    position: absolute;
    width: 100%;
    height: 350px;
    left: 0px;
    top: 400px;
    justify-content: space-around;
    align-items: center;
    padding: 0 10rem;
  }

  .vertical-divider{
    border-right: 5px solid #F5F5F5;
    margin: 1rem;
    height: 70px;
  }

  .carousel-arrow {
    opacity: 1 !important;
    .icon {
      color: #363636;
      &.has-icons-left {
        top: 90%;
        background-color: #FDB913;
        padding: 1rem;
        border-radius: 0;
        border: 0;
        width: 52px;
        // right: 55%;
        transform: translate(-50%, -50%);
        display: flex !important;
      }
      &.has-icons-right {
        top: 90%;
        background-color: #FDB913;
        padding: 1rem;
        border-radius: 0;
        border: 0;
        width: 52px;
        right: 40%;
        display: flex !important;
      }
    }
  }

  .carousel-indicator.is-inside.is-bottom{
    bottom: 5rem !important;
    margin: -0.5rem 1rem;
  }


  .carousel-indicator .indicator-item .indicator-style.is-dots{
    border-radius: 10%;
    width: 15px;
    height: 15px;
    opacity: 60%;
  }

  .carousel-indicator .indicator-item.is-active .indicator-style, .carousel .carousel-indicator .indicator-item .indicator-style:hover{
    background: #FFFFFF;
    border: 1px solid #FFFFFF;
    opacity: 100%;
  }

  .carousel-indicator.is-inside.is-bottom{
      bottom: 5rem !important;
      margin: -0.5rem 0rem !important;
    }
  }
}

  :deep(){

  }

  .track-record-container{
    max-width: 1500px !important;
  }

  .event-activities-title{
    margin-top: 5rem;
  }

  .follow-us-title{
    margin: 5rem;
  }

  .follow-us-box{
    margin-top: 1rem;
    margin-bottom: 5.65rem;
    padding-top: 1.8rem;
  }
}

@media screen and (min-width: 1989px){
  .follow-us-box{
      margin-top: 1rem;
      margin-bottom: 5.65rem;
      padding-top: 10rem;
    }
}


@media screen and (max-width:1989px) and (min-width:1810px){
  // Desktop carousel
  :deep() {

    .carousel-arrow .icon.has-icons-left {
      left: unset;
    }

    .carousel {
      .carousel-list {
        padding-top: 5rem;
      }

      .slider-counter {
        position: absolute;
        top: 50%;
        right: 20%;
      }

      .carousel-text-container{
        position: absolute;
        width: 100%;
        height: 350px;
        left: 0px;
        top: 400px;
        justify-content: space-around;
        align-items: center;
        padding: 0 10rem;
      }

      .vertical-divider{
        border-right: 5px solid #F5F5F5;
        margin: 1rem;
        height: 70px;
      }

      .carousel-arrow {
        opacity: 1 !important;
        .icon {
          color: #363636;
          &.has-icons-left {
            top: 90%;
            background-color: #FDB913;
            padding: 1rem;
            border-radius: 0;
            border: 0;
            width: 52px;
            right: 55%;
            display: flex !important;
          }
          &.has-icons-right {
            top: 90%;
            background-color: #FDB913;
            padding: 1rem;
            border-radius: 0;
            border: 0;
            width: 52px;
            right: 40%;
            display: flex !important;
          }
        }
      }

      .carousel-indicator.is-inside.is-bottom{
        bottom: 5rem !important;
        margin: -0.5rem 1rem;
      }


      .carousel-indicator .indicator-item .indicator-style.is-dots{
        border-radius: 10%;
        width: 15px;
        height: 15px;
        opacity: 60%;
      }

      .carousel-indicator .indicator-item.is-active .indicator-style, .carousel .carousel-indicator .indicator-item .indicator-style:hover{
        background: #FFFFFF;
        border: 1px solid #FFFFFF;
        opacity: 100%;
      }

    }
  }

  // Track record
  .track-record-container{
    margin-top: -9rem;
  }

  .moment-carousel-container{
    margin-top: -4rem;
  }

  // Moment carousel
  :deep(){
    #moment-carousel{
      bottom: 180px;
      .carousel .carousel-items{
        bottom: 100px !important;
      }

      .carousel-arrow {
        opacity: 1 !important;
        .icon {
          color: #363636;
          &.has-icons-left {
            top: 50%;
            background-color: #FDB913;
            padding: 1rem;
            border-radius: 0;
            border: 0;
            width: 52px;
            right: 83%;
            display: flex;
          }
          &.has-icons-right {
            top: 50%;
            background-color: #FDB913;
            padding: 1rem;
            border-radius: 0;
            border: 0;
            width: 52px;
            right: 0;
            display: flex;
          }
        }
      }
    }
  }


  // AWP Moment
  .follow-us-title{
    text-decoration: underline;
    text-decoration-thickness: 8px;
    text-underline-offset: 0.75rem;
  }
}

@media screen and (min-width: 1589px) and (max-width: 1660px) {
  :deep(){
    .carousel-indicator.is-inside.is-bottom{
        bottom: 5rem !important;
        margin: 0 0.5rem;
      }
  }
}

@media screen and (max-width: 1589px) and (min-width: 1440px) {

  :deep(){
    .container{
      left: 2rem !important;
      margin-top: 11rem;
    }
    .carousel-text-container{
      position: absolute !important;
      top: 20% !important;
      left: 1% !important;
    }

    .carousel-indicator.is-inside.is-bottom{
      bottom: 6rem !important;
      margin: 0 0.5rem !important;
    }
  }

  .container{
    margin-top: 0rem;
  }

  // Track record section
  .track-record-container{
    margin-top: -8rem;
  }

}

@media (min-width: 1291px) and (max-width: 1430px) {
  :deep() {
    .carousel-arrow .icon.has-icons-left {
      left: unset;
    }

    .carousel {
      .carousel-list {
        padding-top: 5rem;
      }

      .slider-counter {
        position: absolute;
        top: 50%;
        right: 20%;
      }

      .carousel-text-container{
        position: absolute;
        width: 100%;
        height: 350px;
        left: 0px;
        top: 311px;
        justify-content: space-around;
        align-items: center;
        padding: 0 10rem;
      }


      .carousel-arrow {
        opacity: 1 !important;
        .icon {
          color: #363636;
          &.has-icons-left {
            top: 90%;
            background-color: #FDB913;
            padding: 1rem;
            border-radius: 0;
            border: 0;
            width: 52px;
            right: 55%;
            display: flex !important;
          }
          &.has-icons-right {
            top: 90%;
            background-color: #FDB913;
            padding: 1rem;
            border-radius: 0;
            border: 0;
            width: 52px;
            right: 40%;
            display: flex !important;
          }
        }
      }

      .carousel-indicator.is-inside.is-bottom{
        // bottom: 6rem !important;
      }


      .carousel-indicator .indicator-item .indicator-style.is-dots{
        border-radius: 10%;
        width: 15px;
        height: 15px;
        opacity: 60%;
      }

      .carousel-indicator .indicator-item.is-active .indicator-style, .carousel .carousel-indicator .indicator-item .indicator-style:hover{
        background: #FFFFFF;
        border: 1px solid #FFFFFF;
        opacity: 100%;
      }

    }
  }
}

@media screen and (min-width: 1408px) and (max-width: 1660px) {
  .track-record-section{
    height: 200px;
  }

  .event-card-box{
    min-height: 160px;
    height: 100%;
  }
  .track-record-container{
    margin-top: -11rem;
  }

  .card {
    height: 350px;
  }

  .welcome-box, .weekly-market-box {
    max-width: 550px;
  }

  .track-record-content{
    // width: 280px;
    max-height: 100%;
    height: 300px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-shadow: 0px 4px 30px 5px rgba(0,0,0,0.1);
  }
  .carousel-indicator.is-inside.is-bottom{
    bottom: 6.5rem !important;
    margin: -0.5rem 1rem;
  }
}

@media screen and (max-width: 1330px) {

  :deep(){
    .carousel-text-container{
      position: absolute;
      top: 5%;
      left: 8%;
    }
  }
}

@media(min-width: 1200px) and (max-width: 1500px) {
  :deep(){
    .carousel-text-container{
      height: 270px;
      top: 255px;
      padding: 0 7rem;
    }

    .carousel-indicator.is-inside.is-bottom{
      bottom: 6rem !important;
    }
  }

  .moment-carousel-container{
    margin-top: -11rem;
  }

  :deep(){
    .carousel-indicator.is-inside.is-bottom{
      bottom: 6rem !important;
      margin: 0rem 0.5rem;
    }
  }
}

// @media (min-width: 1408px){
//   :deep(){
//     .carousel-indicator.is-inside.is-bottom{
//       bottom: 5rem !important;
//       margin: 0 auto;
//     }
//   }
// }
@media (min-width: 1024px) and (max-width: 1215px){
  .track-record-content{
    // width: 200px;
    max-height: 100%;
    height: 245px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-shadow: 0px 4px 30px 5px rgba(0,0,0,0.1);
  }

  .card {
    height: 300px;
  }

  .welcome-box, .weekly-market-box {
    max-width: 500px;
  }

  .welcome-box {
    margin-left: 7rem;
  }

  // Event Carousel
  :deep(){
    #event-carousel {
      .carousel-indicator{
        display: none;
      }

      .carousel-list.has-shadow {
        box-shadow:none !important;
      }

      .carousel-arrow {
        opacity: 1 !important;
        .icon {
          color: #363636;
          &.has-icons-left {
            top: 5%;
            background-color: #FDB913;
            padding: 1rem;
            border-radius: 0;
            border: 0;
            width: 52px;
            right: 8%;
            display: flex !important;
          }
          &.has-icons-right {
            top: 5%;
            background-color: #FDB913;
            padding: 1rem;
            border-radius: 0;
            border: 0;
            width: 52px;
            right: 3%;
            display: flex !important;
          }
        }
      }
    }
  }

}

@media (min-width: 1216px) and (max-width: 1407px){
  .banner-section-homepage {
    min-height: 680px;
  }

  .event-card-box{
    min-height: 135px;
    height: 100%;
  }

  .track-record-section{
    height: 300px;
  }

  .card {
    height: 300px;
  }

  .welcome-box, .weekly-market-box {
    max-width: 500px;
  }

  .track-record-container{
    margin-top: -11rem;
  }

  :deep() {
    .carousel-arrow .icon.has-icons-left {
      left: unset;
    }

    .carousel {
      .carousel-list {
        padding-top: 5rem;
      }

      .slider-counter {
        position: absolute;
        top: 50%;
        right: 20%;
      }

      .carousel-text-container{
        position: absolute;
        width: 100%;
        height: 350px;
        left: 0px;
        top: 400px;
        justify-content: space-around;
        align-items: center;
        padding: 0 10rem;
      }

      .vertical-divider{
        border-right: 5px solid #F5F5F5;
        margin: 1rem;
        height: 70px;
      }

      .carousel-arrow {
        opacity: 1 !important;
        .icon {
          color: #363636;
          &.has-icons-left {
            top: 90%;
            background-color: #FDB913;
            padding: 1rem;
            border-radius: 0;
            border: 0;
            width: 52px;
            right: 55%;
            display: flex !important;
          }
          &.has-icons-right {
            top: 90%;
            background-color: #FDB913;
            padding: 1rem;
            border-radius: 0;
            border: 0;
            width: 52px;
            right: 40%;
            display: flex !important;
          }
        }
      }

      .carousel-indicator.is-inside.is-bottom{
        bottom: 4.5rem !important;
        // margin: -0.5rem 0.5rem;
      }


      .carousel-indicator .indicator-item .indicator-style.is-dots{
        border-radius: 10%;
        width: 15px;
        height: 15px;
        opacity: 60%;
      }

      .carousel-indicator .indicator-item.is-active .indicator-style, .carousel .carousel-indicator .indicator-item .indicator-style:hover{
        background: #FFFFFF;
        border: 1px solid #FFFFFF;
        opacity: 100%;
      }

    }
  }
  .pb-banner-title {
    font-family: "Gotham";
    font-weight: 500;
    font-size: 100px;
    line-height: 160px;
    margin-top: -80px;
  }

  .track-record-content{
    // width: 240px;
    max-height: 100%;
    height: 260px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-shadow: 0px 4px 30px 5px rgba(0,0,0,0.1);
  }
}

@media screen and (min-width: 1291px) and (max-width:1660px){
  :deep(){
    .carousel-indicator.is-inside.is-bottom{
      bottom: 5rem !important;
      margin: -0.5rem 0.5rem !important;
    }
  }

  .follow-us-box{
    margin-top: 1rem;
    margin-bottom: 5.65rem;
  }

  .modal-card{
    // width: 641px;
  }
}



@media screen and (max-width:1290px) and (min-width: 1022px) {

  :deep() {
    .carousel-arrow .icon.has-icons-left {
      left: unset;
    }

    .carousel {
      .carousel-list {
        padding-top: 5rem;
      }

      .slider-counter {
        position: absolute;
        top: 50%;
        right: 20%;
      }

      .carousel-text-container{
        position: absolute;
        width: 100%;
        height: 350px;
        left: 0px;
        top: 400px;
        justify-content: space-around;
        align-items: center;
        padding: 0 10rem;
      }

      .vertical-divider{
        border-right: 5px solid #F5F5F5;
        margin: 1rem;
        height: 70px;
      }

      .carousel-arrow {
        opacity: 1 !important;
        .icon {
          color: #363636;
          &.has-icons-left {
            top: 90%;
            background-color: #FDB913;
            padding: 1rem;
            border-radius: 0;
            border: 0;
            width: 52px;
            // right: 55%;
            transform: translate(0%, -50%);
            display: flex !important;
          }
          &.has-icons-right {
            top: 90%;
            background-color: #FDB913;
            padding: 1rem;
            border-radius: 0;
            border: 0;
            width: 52px;
            // right: 40%;
            transform: translate(-12%, -50%);
            display: flex !important;
          }
        }
      }

      .carousel-indicator.is-inside.is-bottom{
        bottom: 4rem !important;
        margin: 0 auto;
      }

      .carousel-indicator .indicator-item .indicator-style.is-dots{
        border-radius: 10%;
        width: 15px;
        height: 15px;
        opacity: 60%;
      }

      .carousel-indicator .indicator-item.is-active .indicator-style, .carousel .carousel-indicator .indicator-item .indicator-style:hover{
        background: #FFFFFF;
        border: 1px solid #FFFFFF;
        opacity: 100%;
      }

    }
  }

  .track-record-container{
    margin-top: -150px;
  }

  .carousel-indicator.is-inside.is-bottom{
    bottom: 5rem;
  }

  .has-bg-img2{
    padding-left: 20px !important;
    padding-right: 20px !important;
  }

  // Moment carousel
  .moment-carousel-container{
    margin-top: -13rem;
  }
  :deep(){
    #moment-carousel{
      .carousel .carousel-items{
        bottom: 100px !important;
      }

      .carousel-list{
        bottom: 130px;
      }

      .carousel-arrow {
        opacity: 1 !important;
        .icon {
          color: #363636;
          &.has-icons-left {
            top: 50%;
            background-color: #FDB913;
            padding: 1rem;
            border-radius: 0;
            border: 0;
            width: 52px;
            right: 83%;
            display: flex;
          }
          &.has-icons-right {
            top: 50%;
            background-color: #FDB913;
            padding: 1rem;
            border-radius: 0;
            border: 0;
            width: 52px;
            right: 0;
            display: flex;
          }
        }
      }
    }
  }

  // AWP Moment
  .follow-us-title{
    text-decoration: underline;
    text-decoration-thickness: 5px;
    text-underline-offset: 0.5rem;
    margin-bottom: 12rem !important;
  }

  .follow-us-box{
    margin-top: 1rem;
    margin-bottom: 5.65rem;
  }
}

@media screen and (min-width: 1024px) and (max-width: 1407px){
  .banner-section-homepage {
    min-height: 680px;
  }

  :deep(){
    .carousel-subtitle{
      font-family: 'GothamBook';
      max-width: 400px;
    }

    .vertical-divider{
      border-right: 5px solid #F5F5F5;
      margin: 1rem;
      height: 60px !important;
    }
  }
}

@media screen and (min-width: 1024px){
  :deep(){
    #moment-carousel{
      .carousel .carousel-items{
        bottom: 100px !important;
      }

      .carousel-arrow {
        opacity: 1 !important;
        .icon {
          color: #363636;
          &.has-icons-left {
            top: 50%;
            background-color: #FDB913;
            padding: 1rem;
            border-radius: 0;
            border: 0;
            width: 52px;
            right: 83%;
            display: flex;
          }
          &.has-icons-right {
            top: 50%;
            background-color: #FDB913;
            padding: 1rem;
            border-radius: 0;
            border: 0;
            width: 52px;
            right: 0;
            display: flex;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1023px) and (min-width: 951px) {

  .carousel-text-container{
    position: absolute;
    top: 25%;
    left: 8% !important;
  }
}

@media screen and (max-width: 1023px){
  :deep(){
    .homepage-carousel-mobile{
      display: flex;
      justify-content: flex-end;
      background-size: cover;
      background-repeat: no-repeat;
      margin-top: -7rem;

      .carousel-text-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        z-index: 1;
        margin-block: unset;
        flex-wrap: wrap;
        margin-top: 10%;
        top:4rem !important;
      }
      .vertical-divider{
        border-right: none !important;
        border-bottom: 5px solid #F5F5F5 !important;
        width: 10rem;
        margin: 0 auto;
        margin: 1rem;
      }

      .carousel-indicator.is-inside.is-bottom{
        bottom: 3rem !important;
        margin-left: 0.5rem;
      }

      .carousel-indicator .indicator-item .indicator-style.is-dots{
        border-radius: 10%;
        width: 15px;
        height: 15px;
        opacity: 60%;
      }

      .carousel-indicator .indicator-item.is-active .indicator-style, .carousel .carousel-indicator .indicator-item .indicator-style:hover{
        background: #FFFFFF;
        border: 1px solid #FFFFFF;
        opacity: 100%;
      }

      .pb-title{
        margin: 1rem 0;
      }
      .join-us-btn{
        // width: 100px;
        background: #FDB913;
        font-weight: 400;
        color: #363636;
        font-size: 16px;
        margin-top: 10px;
      }
    }
  }

  .card {
    height: 390px;
  }

  .card-content{
    // padding-top: 4rem;
    // max-height: 400px;
    height: 100%;
    padding: 3.68rem 1.5rem 0;
  }

  .welcome-box  .button.main,.weekly-market-box .button.main {
    margin-top: 1.5rem !important;
  }

  .welcome-box, .weekly-market-box {
    max-width: 500px;
  }

  .pb-large-title{
    margin-left: 1.2rem !important;
    margin-right: 4.6rem !important;
  }

  .welcome-text{
    margin: unset;
  }

  .welcome-box{
    margin-left: unset;
    margin-right: unset;
  }

  .weekly-market-box{
    margin-left: unset;
    margin-right: unset;
  }

  .track-record-title{
    margin: unset;
  }

  .join-us-btn{
    width: auto !important;
  }

  .event-activities-title{
    margin: 3.125rem;
  }

  .follow-us-box{
    margin-top: 1rem;
    margin-bottom: 5.65rem;
  }

  .track-record-section{
    margin-top: 6rem;
  }

  .track-record-content{
    width: 100%;
    max-height: 100%;
    height: 300px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-shadow: 0px 4px 30px 5px rgba(0,0,0,0.1);
  }

  .event-card-box{
    min-height: 135px;
    height: 100%;
  }
  .modal-card{
    // width: 345px !important;
  }

  .icon-container{
    display: block;
  }
}

@media screen and (max-width: 1023px) and (min-width: 769px) {
  :deep(){
    .homepage-carousel-mobile {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      background-size: cover;
      background-repeat: no-repeat;
      margin-top: -7rem;

      .carousel-arrow {
        opacity: 1 !important;
        .icon {
          color: #363636;
          &.has-icons-left {
            top: 90%;
            right: 62% !important;
          }
          &.has-icons-right {
            top: 90%;
            right: 35% !important;
          }
        }
      }

      .carousel-text-container .join-us-btn{
        background: #FDB913;
        font-weight: 400;
        color: #363636;
        font-size: 16px;
        top: 100%;
      }

      .vertical-divider{
        border-bottom: 5px solid #F5F5F5 !important;
        margin: 1rem auto;
        width: 30%;
        border-right: none;
        height: 0 !important;
      }

      .carousel-indicator.is-inside.is-bottom{
        bottom: 4rem !important;
        margin-left: -0.5rem;
      }

      .carousel-indicator .indicator-item .indicator-style.is-dots{
        border-radius: 10%;
        width: 15px;
        height: 15px;
        opacity: 60%;
      }

      .carousel-indicator .indicator-item.is-active .indicator-style, .carousel .carousel-indicator .indicator-item .indicator-style:hover{
        background: #FFFFFF;
        border: 1px solid #FFFFFF;
        opacity: 100%;
      }
    }
  }

  .track-record-content{
    // width: 200px;
    max-height: 100%;
    height: 245px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-shadow: 0px 4px 30px 5px rgba(0,0,0,0.1);
  }

  .pb-banner-title{
    text-align: center !important;
    margin-top: 20px;
  }

  // Moment title
  .follow-us-title{
    text-decoration: underline 5px;
    text-underline-offset: 0.5rem;
  }

  .moment-carousel-container{
    margin-top: -11rem;
  }

  // Event Carousel
  :deep(){
    #event-carousel {
      .carousel-indicator{
        display: none;
      }

      .carousel-list.has-shadow {
        box-shadow:none !important;
      }

      .carousel-arrow {
        opacity: 1 !important;
        .icon {
          color: #363636;
          &.has-icons-left {
            top: 5%;
            background-color: #FDB913;
            padding: 1rem;
            border-radius: 0;
            border: 0;
            width: 10px;
            right: 6%;
            display: flex !important;
          }
          &.has-icons-right {
            top: 5%;
            background-color: #FDB913;
            padding: 1rem;
            border-radius: 0;
            border: 0;
            width: 10px;
            right: 3%;
            display: flex !important;
          }
        }
      }
    }
  }

  .icon-container{
    display: flex;
    flex-direction: column;
  }
}

@media screen and (max-width: 967px) and (min-width: 769px){
  .track-record-content{
    width: 100%;
    max-height: 100%;
    height: 260px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-shadow: 0px 4px 30px 5px rgba(0,0,0,0.1);
  }
}

@media screen and (max-width: 768px){
  .pb-banner-title{
    margin-top: 50px;
  }

  .wrapper-contact {
    display: block;
    text-align: center;

    a {
      padding: 0.3rem 0;
      justify-content: center !important;
    }
  }

  .has-bg-img2{
    max-height: max-content !important;
    height: auto !important;
    margin-bottom: 10px !important;
  }

  // Homepage carousel
  :deep(){
    .homepage-carousel-mobile {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      background-size: cover;
      background-repeat: no-repeat;
      margin-top: -7rem;

      .carousel-arrow {
        opacity: 1 !important;
        .icon {
          color: #363636;
          &.has-icons-left {
            top: 90%;
            right: 75% !important;
          }
          &.has-icons-right {
            top: 90%;
            right: 15% !important;
          }
        }
      }

      .carousel-text-container .join-us-btn{
        background: #FDB913;
        font-weight: 400;
        color: #363636;
        font-size: 16px;
        top: 100%;
      }
      .vertical-divider{
        border-bottom: 5px solid #F5F5F5 !important;
        margin: 1rem auto;
        border-right: none;
        height: 0 !important;
      }

      .carousel-indicator.is-inside.is-bottom{
        bottom: 4rem !important;
        margin-left: -0.5rem;
      }

      .carousel-indicator .indicator-item .indicator-style.is-dots{
        border-radius: 10%;
        width: 15px;
        height: 15px;
        opacity: 60%;
      }

      .carousel-indicator .indicator-item.is-active .indicator-style, .carousel .carousel-indicator .indicator-item .indicator-style:hover{
        background: #FFFFFF;
        border: 1px solid #FFFFFF;
        opacity: 100%;
      }
    }
  }

  // Moment title
  .follow-us-title{
    text-decoration: underline 5px;
    text-underline-offset: 0.3rem;
  }

  .moment-carousel-container{
    margin-top: -1rem;
  }

  // Moment Carousel
  :deep(){
    #moment-carousel {
      .carousel .carousel-items{
        bottom: 100px !important;
      }
    }
  }

  .modal-card{
    // width: 345px !important;
  }
}

@media screen and (max-width:768px) and (min-width:509px) {
  // Event Carousel
  :deep(){
    #event-carousel {
      .carousel-indicator{
        display: none;
      }

      .carousel-list.has-shadow {
        box-shadow:none !important;
      }

      .carousel-arrow {
        opacity: 1 !important;
        .icon {
          color: #363636;
          &.has-icons-left {
            top: 4%;
            right: 8%;
            width: 10px;
            display: flex !important;
          }
          &.has-icons-right {
            top: 4%;
            right: 4%;
            width: 10px;
            display: flex !important;
          }
        }
      }
    }
  }

  // Moment Carousel
  .moment-carousel-container{
    margin-top: -11rem;
  }

  :deep(){
    #moment-carousel {
      .carousel .carousel-items{
        bottom: 100px !important;
      }

      .carousel-arrow {
        opacity: 1 !important;
        .icon {
          color: #363636;
          &.has-icons-left {
            top: 50%;
            background-color: #FDB913;
            padding: 1rem;
            border-radius: 0;
            border: 0;
            width: 52px;
            right: 83%;
            display: flex;
          }
          &.has-icons-right {
            top: 50%;
            background-color: #FDB913;
            padding: 1rem;
            border-radius: 0;
            border: 0;
            width: 52px;
            right: 0;
            display: flex;
          }
        }
      }
    }
  }

  .follow-social-media-title{
    font-weight: 700;
    color: #F5F5F5;
    margin-top: 1rem;
    margin-bottom: 2rem;
  }
}

@media screen and (max-width: 508px){
  // Event Carousel
  :deep(){
    #event-carousel {
      .carousel-indicator{
        display: none;
      }

      .carousel-list.has-shadow {
        box-shadow:none !important;
      }

      .carousel-arrow {
        opacity: 1 !important;
        .icon {
          color: #363636;
          &.has-icons-left {
            top: 5%;
            width: 10px;
            right: 12%;
            display: flex !important;
          }
          &.has-icons-right {
            top: 5%;
            width: 10px;
            right: 6%;
            display: flex !important;
          }
        }
      }
    }
  }

  // Moment Carousel
  .moment-carousel-container{
    margin-top: -11rem;
  }

  :deep(){
    #moment-carousel {
      .carousel .carousel-items{
        bottom: 100px !important;
      }

      .carousel-arrow {
        opacity: 1 !important;
        .icon {
          color: #363636;
          &.has-icons-left {
            top: 50%;
            background-color: #FDB913;
            padding: 1rem;
            border-radius: 0;
            border: 0;
            width: 52px;
            right: 83%;
            display: flex ;
          }
          &.has-icons-right {
            top: 50%;
            background-color: #FDB913;
            padding: 1rem;
            border-radius: 0;
            border: 0;
            width: 52px;
            right: 0;
            display: flex;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 496px){

  .carousel-text-container{
    position: absolute;
    top: 5%;
    left: 20%;
  }

  .join-us-btn{
    // width: 150px;
    background: #FDB913;
    font-weight: 400;
    color: #363636;
    font-size: 18px;
  }

  .first-title{
    margin-right: 47px;
    font-size: 24px;
    font-weight: 700;
  }

  .vertical-divider{
    border-right: 0px;
    width: 70px !important;
  }

  // Welcome
  .welcome-image-section{
    width: 100% !important;
    border-bottom: 3px solid #FDB913;
  }

  #weekly-market-section{
    max-height: 400px;
    height: 100%;
    position: relative;
    transform: translate(0,0);
    border-bottom: 10px solid #FDB913;
    width: 100%;
  }

  #weekly-market-section > p{
    font-size: 16px !important;
    font-weight: 400;
  }

  #weekly-market-section > p{
    font-size: 16px !important;
    font-weight: 400;
  }

  // Track Record
  .track-record-section{
    margin-top: 100px;
  }

  .track-record-content{
    margin-top: -18px;
  }
  .number-source{
    width: 280px;
    font-size: 18px;
    margin: 0 auto;
  }

  // AWP Moment
  .follow-us-title{
    font-size: 25px;
    font-weight: 700;
  }

  .moment-carousel-container{
    margin-top: -11rem;
  }

  // Moment Carousel
  .moment-carousel-container{
    margin-top: -11rem;
  }

  :deep(){
    #moment-carousel {
      .carousel .carousel-items{
        bottom: 100px !important;
      }

      .carousel-arrow {
        opacity: 1 !important;
        .icon {
          color: #363636;
          &.has-icons-left {
            top: 50%;
            background-color: #FDB913;
            padding: 1rem;
            border-radius: 0;
            border: 0;
            width: 5px;
            right: 83%;
            display: flex;
          }
          &.has-icons-right {
            top: 50%;
            background-color: #FDB913;
            padding: 1rem;
            border-radius: 0;
            border: 0;
            width: 10px;
            right: 0;
            display: flex;
          }
        }
      }
    }
  }

  .follow-social-media-title{
    font-weight: 700;
    color: #F5F5F5;
    margin-top: 1rem;
    margin-bottom: 2rem;
  }

  .indicator-style.is-dots{
    display: none;
  }

}

@media screen and (max-width: 425px){

  .section{
    margin-right: 0px !important;
    margin-left: 0px !important;
  }

  // Moment title
  .follow-us-title{
    text-decoration: underline 5px;
    text-underline-offset: 0.3rem;
  }

  // Moment Carousel
  .moment-carousel-container{
    margin-top: -11rem;
  }

  :deep(){
    #moment-carousel {
      .carousel .carousel-items{
        bottom: 100px !important;
      }

      .carousel-arrow {
        opacity: 1 !important;
        .icon {
          color: #363636;
          &.has-icons-left {
            top: 50%;
            background-color: #FDB913;
            padding: 1rem;
            border-radius: 0;
            border: 0;
            width: 52px;
            right: 83%;
            display: flex;
          }
          &.has-icons-right {
            top: 50%;
            background-color: #FDB913;
            padding: 1rem;
            border-radius: 0;
            border: 0;
            width: 52px;
            right: 0;
            display: flex;
          }
        }
      }
    }
  }

  .icon-container{
    display: flex;
    flex-direction: column;
  }
}

@media screen and (max-width: 375px){
  .pb-large-title{
    margin-left: 1.5rem !important;
    margin-right: 4.6rem !important;
  }

  // Event Carousel
  :deep(){
    #event-carousel {
      .carousel-indicator{
        display: none;
      }

      .carousel-list.has-shadow {
        box-shadow:none !important;
      }

      .carousel-arrow {
        opacity: 1 !important;
        .icon {
          color: #363636;
          &.has-icons-left {
            top: 5%;
            right: 20%;
            display: flex !important;
          }
          &.has-icons-right {
            top: 5%;
            right: 5%;
            display: flex !important;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 358px){
  :deep(){
    .homepage-carousel-mobile {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      background-size: cover;
      background-repeat: no-repeat;
      margin-top: -7rem;

      .carousel-text-container {
        position: absolute;
        top: 5rem !important;
        left: -40%;
      }

      .join-us-btn{
        background: #FDB913;
        font-weight: 400;
        color: #363636;
        font-size: 16px;
        top: 100%;
      }

      .carousel-arrow {
        opacity: 1 !important;
        .icon {
          color: #363636;
          // &.has-icons-left {
          //   top: 90%;
          //   background-color: #FDB913;
          //   padding: 1rem;
          //   border-radius: 0;
          //   border: 0;
          //   width: 52px;
          //   right: 65%;
          //   // transform: translate(-50%, -50%);
          //   display: flex !important;
          // }
          // &.has-icons-right {
          //   top: 90%;
          //   background-color: #FDB913;
          //   padding: 1rem;
          //   border-radius: 0;
          //   border: 0;
          //   width: 52px;
          //   right: 30% !important;
          //   // transform: translate(50%, -50%) !important;
          //   display: flex !important;
          // }
        }
      }

      .vertical-divider{
        border-right: 0px;
        border-top: 0px solid #F5F5F5;
        width: 70px;
        // margin: 2rem 0 !important;
      }

      .carousel-indicator.is-inside.is-bottom{
        bottom: 4rem !important;
        // margin-left: 0.5rem;
      }

      .carousel-indicator .indicator-item .indicator-style.is-dots{
        border-radius: 10%;
        width: 15px;
        height: 15px;
        opacity: 60%;
      }

      .carousel-indicator .indicator-item.is-active .indicator-style, .carousel .carousel-indicator .indicator-item .indicator-style:hover{
        background: #FFFFFF;
        border: 1px solid #FFFFFF;
        opacity: 100%;
      }
    }
  }

  :deep(){
    #event-carousel {
      .carousel-indicator{
        display: none;
      }

      .carousel-list.has-shadow {
        box-shadow:none !important;
      }

      .carousel-arrow {
        opacity: 1 !important;
        .icon {
          color: #363636;
          &.has-icons-left {
            top: 5%;
            right: 20%;
            display: flex !important;
          }
          &.has-icons-right {
            top: 5%;
            right: 9%;
            display: flex !important;
          }
        }
      }
    }
  }

  // Track section

  .track-record-container{
    margin-top: -120px;
  }

  .track-record-box{
    height: 300px;
  }

  .pb-subtitle-2{
    margin: 0.75rem;
  }

  // Welcome section
  .card-content{
    // padding-top: 4rem;
    // max-height: 400px;
    // height: 100%;
    padding: 1.5rem;
  }
  .welcome-container{
    margin-top: -50px !important;
  }

  .welcome-text-section{
    border-bottom: 10px solid #FDB913;
    box-shadow: 0px 2px 30px 5px rgba(0,0,0,0.4)
  }

 // Welcome
  .follow-us-title{
    text-decoration: underline 5px;
    text-underline-offset: 0.5rem;
  }

  // Moment Carousel
  .moment-carousel-container{
    margin-top: -11rem;
  }

  :deep(){
    #moment-carousel {
      .carousel-arrow {
        opacity: 1 !important;
        .icon {
          color: #363636;
          &.has-icons-left {
            top: 50%;
            background-color: #FDB913;
            padding: 1rem;
            border-radius: 0;
            border: 0;
            width: 52px;
            right: 83%;
            display: flex;
          }
          &.has-icons-right {
            top: 50%;
            background-color: #FDB913;
            padding: 1rem;
            border-radius: 0;
            border: 0;
            width: 52px;
            right: 0;
            display: flex;
          }
        }
      }
    }
  }

}
</style>
